(function () {
  if (!document.querySelector('.collection-description-banner')) return;

  function initBanner(banner) {
    const enableReadMore = banner.dataset.enableReadMore === 'true';
    if (!enableReadMore) return;

    const textContainer = banner.querySelector('.collection-description-banner__text');
    const toggleButton = banner.querySelector('.collection-description-banner__toggle');
    if (!textContainer || !toggleButton) return;

    const collapsedHeight = parseInt(banner.dataset.collapsedHeight) || 200;
    const readMoreLabel = toggleButton.dataset.readMoreLabel || 'Read more';
    const readLessLabel = toggleButton.dataset.readLessLabel || 'Read less';

    const textInner = textContainer.querySelector('.collection-description-banner__text-inner');
    if (textInner && textInner.scrollHeight <= collapsedHeight) {
      // No need for collapsible UI
      textContainer.classList.remove('cdb--collapsible', 'cdb--expanded');
      toggleButton.hidden = true;
      const fade = textContainer.querySelector('.collection-description-banner__fade');
      if (fade) fade.style.display = 'none';
      banner.classList.add('cdb--ready');
      return;
    }

    // Show toggle only when needed
    toggleButton.hidden = false;
    banner.classList.add('cdb--ready');

    toggleButton.addEventListener('click', function () {
      const isExpanded = textContainer.classList.contains('cdb--expanded');
      if (isExpanded) {
        textContainer.classList.remove('cdb--expanded');
        toggleButton.textContent = readMoreLabel;
        toggleButton.setAttribute('aria-expanded', 'false');
      } else {
        textContainer.classList.add('cdb--expanded');
        toggleButton.textContent = readLessLabel;
        toggleButton.setAttribute('aria-expanded', 'true');
      }
    });
  }

  function init() {
    document.querySelectorAll('.collection-description-banner[data-enable-read-more]').forEach(initBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
